import { inBrowser } from 'vessel/utils'

export let visible = []

function onKeydown(event) {
  const focused = visible[visible.length - 1]

  if (focused) {
    focused.$emit('keydown', event)

    if (focused.closeOnEsc && event.code == 'Escape') {
      focused.close()
    }
  }
}

function addListener() {
  if (inBrowser && visible.length == 1) {
    window.addEventListener('keydown', onKeydown)
  }
}

function removeListener() {
  if (inBrowser && visible.length == 0) {
    window.removeEventListener('keydown', onKeydown)
  }
}

export function addVisible(component) {
  const exists = visible.some(comp => comp._uid == component._uid)
  !exists && visible.push(component)

  addListener()
}

export function removeVisible(component) {
  const index = visible.findIndex(comp => comp._uid == component._uid)
  index > -1 && visible.splice(index, 1)

  removeListener()
}
